import {
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  Image,
  Input,
  useToast,
  Switch,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import React, { useContext, useEffect, useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import CreateCity from "./CreateCity/CreateCity";
import SettingSection from "./SettingSection/SettingSection";
import { EditIcon } from "@chakra-ui/icons";
import { useHasPermission } from "../common/PermissionsFunction/permissiosnFunction";

export default function CitiesTable(): JSX.Element {
  const initialDateRange = {
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
    key: "selection",
  };

  const [dateRange, setDateRange] = useState<any>(initialDateRange);
  const { startDate, endDate } = dateRange;
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState<any[]>([]);

  const [editingIndex, setEditingIndex] = useState(-1);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [activePage, setActivePage] = useState("1");
  const [editCity, setEditCity] = useState({});
  const [selectedCityId, setSelectedCityId] = useState<string>("");
  const [selectedCityCode, setselectedCityCode] = useState<string>("");
  const [switchStates, setSwitchStates] = useState<boolean[]>([]);
  const toast = useToast();

  const getCities = async (currentP?: number) => {
    try {
      setLoading(true);
      let page = currentP ? currentP : currentPage;
      let limit = Paginationlimit;
      const request: any = {
        limit,
        page,
        startDate,
        endDate,
      };
      const response: any = await appRequest("metro", "allCities", request);

      if (response.status === "success") {
        setTotalPages(response?.totalPages || 0);
        setData(response?.cities || []);
        console.log("response?.cities", response?.cities)
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item: any) => {
    setEditCity(item);
    setIsCreateModalOpen(true);
  };

  const updateData = async (editedData: any) => {
    try {
      setLoading(true);
      const payload = {
        name: editedData?.name,
        code: editedData?.cityCode,
        image: editedData?.image,
        metroCancellation: editedData?.metroCancellation,
        id: editedData._id,
        operatingHours: {
          start: editedData?.operatingHours?.start,
          end: editedData?.operatingHours?.end,
        },
        gps: {
          latitude: Number(editedData?.gps?.latitude),
          longitude: Number(editedData?.gps?.longitude),
        },
      };
      const result: any = await appRequest("metro", "updateCity", payload);
      if (result.status === "success") {
        toast({
          title: "Success",
          description: "City updated successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
        getCities();
        setIsCreateModalOpen(false);
      }
    } catch (error: any) {
      console.log("Error in updateing City", error);
      toast({
        title: "Error",
        description: "Failed to update city.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (name: string, value: any) => {
    setSwitchStates((prevSwitchStates: any) =>
      prevSwitchStates.map((switchState: any) =>
        switchState.name === name
          ? { ...switchState, isActive: value }
          : switchState
      )
    );
    handleSingleState(name, value);
  };

  const handleSingleState = async (name: any, value: any) => {
    try {
      const payload = {
        id: name,
        isActive: value,
      };
      const result: any = await appRequest(
        "metro",
        "updateCityStatus",
        payload
      );

      if (result.status === "success") {
        toast({
          title: "Success",
          description: "City Status updated successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
        await getCities();
      }
    } catch (error: any) {
      toast({
        title: "Error",
        description: "Failed to update city status.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      console.error(error.message);
    }
  };

  useEffect(() => {
    getCities();
  }, [currentPage, endDate]);

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };



  const handleRefreshAllData = () => {
    setDateRange(initialDateRange);
    getCities();
  };

  // Function to handle row click and set the selected city ID
  const handleRowClick = (cityId: string, cityCode: string) => {
    setSelectedCityId(cityId);
    setselectedCityCode(cityCode);
    setActivePage("2");
  };

  const canEditCities = useHasPermission("canEditCities");

  return (
    <>
      {activePage === "1" && (
        <Box
          p={5}
          rounded={"lg"}
          bg={"white"}
          shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
        >
          <Flex
            justify={"space-between"}
            mb={2}
            direction={{ base: "column", md: "row" }}
          >
            <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
              All Cities
            </Text>

            {/* <Flex gap={2} direction={{ base: "column", md: "row" }}>
              <Button
                onClick={() => {
                  setIsCreateModalOpen(true);
                  setEditCity({});
                }}
                colorScheme="teal"
              >
                ADD
              </Button> */}
            <Flex gap={2} justify={"end"}>
              <Button
                onClick={() => {
                  setIsCreateModalOpen(true);
                  setEditCity({});
                }}
                colorScheme="teal"
                size={{ base: "sm", md: "md" }}
              >
                ADD
              </Button>
              <Tooltip label="Refresh" hasArrow>
                <IconButton
                  aria-label="Refresh"
                  icon={<HiOutlineRefresh />}
                  colorScheme="teal"
                  variant="outline"
                  borderWidth={2}
                  _hover={{ bg: "teal.100" }}
                  onClick={handleRefreshAllData}
                  size={{ base: "sm", md: "md" }}
                />
              </Tooltip>
            </Flex>
            {/* </Flex> */}
          </Flex>
          <TableContainer className="customScrollBar" pb={2}>
            <Table>
              <Thead>
                <Tr>
                  <Th></Th>
                  <Th>Name</Th>
                  <Th>City Code</Th>
                  <Th>Metro Cancellation</Th>
                  <Th>Operating Hours</Th>
                  <Th>State</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <TableLoader
                noDataText="No Cities  Available"
                show={data?.length}
                loader={loading}
              >
                <Tbody>
                  {data?.map((city, index) => (
                    <Tr
                      key={city._id}
                      _hover={{ bg: "gray.100" }}
                      className={JSON.stringify(index)}
                      cursor={"pointer"}
                      onClick={() => {
                        setActivePage("2");
                        handleRowClick(city._id, city.cityCode);
                      }}
                    >
                      <Td>
                        {city.image ? (
                          <Box
                            boxSize="30px"
                            borderRadius="md"
                            overflow="hidden"
                          >
                            <Image
                              src={city.image}
                              alt={city.name}
                              boxSize="30px"
                              objectFit="contain"
                              borderRadius="md"
                              fallback={
                                <Text fontSize="xs" color="gray.500">
                                  Loading...
                                </Text>
                              }
                            />
                          </Box>
                        ) : (
                          <Text color="gray.500" fontSize="sm">
                            No Image
                          </Text>
                        )}
                      </Td>
                      <Td
                        onClick={(e) => {
                          if (editingIndex !== index) {
                            setActivePage("2");
                          } else {
                            e.stopPropagation();
                          }
                        }}
                        cursor={editingIndex !== index ? "pointer" : "default"}
                      >
                        {editingIndex === index ? (
                          <Input
                            // value={editedCity.name}
                            // onChange={(e) =>
                            //   handleFieldChange("name", e.target.value)
                            // }
                            size="sm"
                            onClick={(e) => e.stopPropagation()}
                          />
                        ) : (
                          <Text fontWeight={500}>{city.name || "N/A"}</Text>
                        )}
                      </Td>
                      <Td>
                        <Text isTruncated maxW={"10rem"}>
                          {city.cityCode || "N/A"}
                        </Text>
                      </Td>
                      <Td>
                        <Tag
                          size="sm"
                          colorScheme={city.metroCancellation ? "green" : "red"}
                        >
                          {city.metroCancellation ? "Yes" : "No"}
                        </Tag>
                      </Td>
                      <Td>
                        <Text>
                          {city.operatingHours
                            ? `${city.operatingHours.start} - ${city.operatingHours.end}`
                            : "N/A"}
                        </Text>
                      </Td>
                      <Td onClick={(e) => e.stopPropagation()}>
                        <Switch
                          size="md"
                          colorScheme="teal"
                          // isChecked={switchStates[index]}
                          isChecked={city.is_active}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleSwitchChange(city._id, e.target.checked);
                          }}
                        />
                      </Td>
                      <Td>
                        {canEditCities && (
                          <IconButton
                            aria-label="edit"
                            icon={<EditIcon />}
                            colorScheme="teal"
                            size="sm"
                            variant={"outline"}
                            mr={2}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(city);
                            }}
                          />
                        )}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </TableLoader>
            </Table>
          </TableContainer>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
          <CommonModal
            header="Add/Update City"
            width={{ base: "100vw", md: "60vw" }}
            animate={true}
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            body={
              <Box>
                <CreateCity
                  getCities={getCities}
                  setIsCreateModalOpen={setIsCreateModalOpen}
                  editData={editCity}
                  onSubmit={updateData}
                />
              </Box>
            }
          />
        </Box>
      )}
      {activePage === "2" && (
        <SettingSection cityId={selectedCityId} cityCode={selectedCityCode} />
      )}
    </>
  );
}
